import React from 'react'
import styled from 'styled-components'

const Bar = styled.div`
    width: 100%;
    height: 50px;
    line-height: 50px;
    text-align: center;
    background: repeating-linear-gradient(135deg, yellow 0px, yellow 20px, black 20px, black 40px);
    border-radius: 10px;
`

const Text = styled.span`
    display: inline-block;
    font-size: 2rem;
    color: yellow;
    height: 100%;
    background-color: black;
    padding-left: 10px;
    padding-right: 10px;
`

const UnderContruction = () => (
    <Bar>
        <Text>Under Construction</Text>
    </Bar>
)

export default UnderContruction



// WEBPACK FOOTER //
// ./src/components/underConstruction.js